import type { ScrapingRunSummary } from '../types';

export function downloadScrapingRunCsv(run: ScrapingRunSummary, csv: string) {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');

  anchor.href = url;
  anchor.download = `scraping-run-${run.run_id}-${run.execution_date}.csv`;
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
